import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

// Sent as the user's first message in a brand-new chat. Says "email outreach
// campaign" outright so Zeph reaches for its campaign tools rather than reading
// "campaign" as a HubSpot segment/list, and asks for options so it answers with the
// tappable choice card instead of a list of open-ended questions.
export const CREATE_CAMPAIGN_PROMPT =
  'I want to create a new email outreach campaign. Give me options to choose from, based on my company profile.'

/**
 * Opens a fresh chat with the create-campaign prompt already sent. ChatPage picks
 * `startPrompt` up from router state (clearing it so a refresh can't replay it) and
 * always starts a new conversation — unlike `zephSeed`, which reopens one per key.
 */
export function useCreateCampaignWithZeph() {
  const navigate = useNavigate()
  return useCallback(() => {
    navigate('/dashboard/chat', { state: { startPrompt: CREATE_CAMPAIGN_PROMPT } })
  }, [navigate])
}
